export default __webpack_public_path__ + "static/media/us-sc.f0d1b825.svg";